import { createApp, h, provide } from "vue";
import App from './App.vue'
import { createMetaManager, plugin as metaPlugin } from "vue-meta";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './assets/css/style.scss'
import router from './router'
import apolloClients from './vue-apollo'
import moment from 'moment-timezone';
import VueGtag from "vue-gtag";
import createStore from './store'
import { ApolloClients } from "@vue/apollo-composable";
import eventBus from "@/utils/event-bus";
import Vue3TouchEvents from "vue3-touch-events";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import {
  clickaway,
  tooltip,
} from "@/utils/directives";

moment.defaultFormat = moment.utc.defaultFormat = "YYYY-MM-DD HH:mm:ss";
moment.tz.setDefault('UTC');


const store = createStore({ apolloClient: apolloClients.default });
const metaManager = createMetaManager();
Promise.all([
  store.dispatch('auth/init'),
  store.dispatch('settings/init'),
  store.dispatch('gas/init'),
]).finally(() => {
  const app = createApp({
    setup() {

      provide(ApolloClients, {
        ...apolloClients,
      });

      // TODO: Get rid of event bus
      provide("requireLogin", () => {
        return new Promise((resolve, reject) => {
          eventBus.$once('auth:didSignIn', resolve)
          eventBus.$emit('auth:signIn');

          setTimeout(() => {
            reject(new Error("Authentication attempt timed out"));
          }, 60 * 1000);
        });
      })
    },

    render: () => h(App),
  });
  Sentry.init({
    app,
    dsn: "https://65fb49ea9379431a80239c37e89a4985@o1302847.ingest.sentry.io/6562991",
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "compass.art", "compassdev.xyz", /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    logErrors: true,
    captureErrors: false,
  });
  app
    .use(store)
    .use(router)
    .use(metaManager)
    .use(metaPlugin)
    .use(Vue3TouchEvents)
    .use(VueGtag, {
      config: {
        id: 'G-YPY1XS3VTN',
        params: {
          send_page_view: false
        }
      }
    }, router);

  app.directive("clickaway", clickaway)
  app.directive("tooltip", tooltip);

  app.mount("#app");
});

